const NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
// const APP_ENV = process.env.APP_ENV;
const APP_AREA = process.env.APP_AREA;

const APP_SITE = process.env.APP_SITE;

// 判断 NEXT_PUBLIC_ENV 环境
export const isDev = NEXT_PUBLIC_ENV === 'development';
export const isQA = NEXT_PUBLIC_ENV === 'qa';
export const isPre = NEXT_PUBLIC_ENV === 'pre';
export const isProduction = NEXT_PUBLIC_ENV === 'production';

// 判断 APP_AREA 区域
export const isCnArea = APP_AREA === 'cn';
export const isUsArea = APP_AREA === 'us';

// 判断 APP_SITE 站点
export const isBWebSite = APP_SITE === 'boomcut';
export const isBCNWebSite = APP_SITE === 'boomcut' && APP_AREA === 'cn';
export const isBUSWebSite = APP_SITE === 'boomcut' && APP_AREA === 'us';
export const isFWebSite = APP_SITE === 'falcocut';

// 组合判断
export const isDevCn = isDev && isCnArea;
export const isDevUs = isDev && isUsArea;
export const isQACn = isQA && isCnArea;
export const isQAUs = isQA && isUsArea;
export const isPreCn = isPre && isCnArea;
export const isPreUs = isPre && isUsArea;
export const isProdCn = isProduction && isCnArea;
export const isProdUs = isProduction && isUsArea;

console.group('Environment Info');
console.log('\x1b[43;30m 🌍 isDevUs \x1b[0m ' + isDevUs);
console.log('\x1b[46;30m 🌱 isQAUs \x1b[0m ' + isQAUs);
console.log('\x1b[41;37m 🔧 isPreUs \x1b[0m ' + isPreUs);
console.log('\x1b[43;30m 🚀 isProdUs \x1b[0m ' + isProdUs);
console.groupEnd();
